"use strict";

var _a, _b, _c, _d;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetEnvVar = exports.setEnvironment = exports.getEnvironment = void 0;

var overrides_1 = require("./overrides");

var window_1 = require("./window");

var REVIEW_APP_HOST = 'dev.hopininternal.com';
var HOSTNAME_ENV_MAP = (_a = {}, _a[REVIEW_APP_HOST] = 'review', _a.localhost = 'staging', _a['assets-cdn-dev.slices.hopin.com'] = 'staging', _a['dev.apps.staging.hopin.com'] = 'staging', _a['stg.dashboard.hopin.com'] = 'staging', _a['dashboard.staging.events.ringcentral.com'] = 'staging', _a['staging.hopin.com'] = 'staging', _a['apps-staging.hopin.com'] = 'staging', _a['apps.staging.events.ringcentral.com'] = 'staging', _a['staging.events.ringcentral.com'] = 'staging', _a['dashboard.hopin.com'] = 'production', _a['dashboard.events.ringcentral.com'] = 'production', _a['hopin.com'] = 'production', _a['de.hopin.com'] = 'production', _a['events.ringcentral.com'] = 'production', _a['apps.hopin.com'] = 'production', _a['apps.events.ringcentral.com'] = 'production', _a);
var EVENTS_HOST = (_b = {}, _b[REVIEW_APP_HOST] = '', _b.localhost = 'staging.events.ringcentral.com', _b['assets-cdn-dev.slices.hopin.com'] = 'staging.events.ringcentral.com', _b['dev.apps.staging.hopin.com'] = 'staging.events.ringcentral.com', _b['stg.dashboard.hopin.com'] = 'staging.events.ringcentral.com', _b['dashboard.staging.events.ringcentral.com'] = 'staging.events.ringcentral.com', _b['staging.hopin.com'] = 'staging.events.ringcentral.com', _b['staging.events.ringcentral.com'] = 'staging.events.ringcentral.com', _b['apps-staging.hopin.com'] = 'staging.events.ringcentral.com', _b['apps.staging.events.ringcentral.com'] = 'staging.events.ringcentral.com', _b['dashboard.hopin.com'] = 'events.ringcentral.com', _b['dashboard.events.ringcentral.com'] = 'events.ringcentral.com', _b['hopin.com'] = 'events.ringcentral.com', _b['de.hopin.com'] = 'events.ringcentral.com', _b['events.ringcentral.com'] = 'events.ringcentral.com', _b['apps.hopin.com'] = 'events.ringcentral.com', _b['apps.events.ringcentral.com'] = 'events.ringcentral.com', _b);
var APPS_STORE_HOST = (_c = {}, _c[REVIEW_APP_HOST] = '', _c.localhost = 'apps.staging.events.ringcentral.com', _c['staging.hopin.com'] = 'apps.staging.events.ringcentral.com', _c['stg.dashboard.hopin.com'] = 'apps.staging.events.ringcentral.com', _c['hopin.com'] = 'apps.events.ringcentral.com', _c['dashboard.hopin.com'] = 'apps.events.ringcentral.com', _c['staging.events.ringcentral.com'] = 'apps.staging.events.ringcentral.com', _c['dashboard.staging.events.ringcentral.com'] = 'apps.staging.events.ringcentral.com', _c['events.ringcentral.com'] = 'apps.events.ringcentral.com', _c['dashboard.events.ringcentral.com'] = 'apps.events.ringcentral.com', _c);
var DASHBOARD_HOST = (_d = {}, _d[REVIEW_APP_HOST] = '', _d.localhost = 'dashboard.staging.events.ringcentral.com', _d['staging.hopin.com'] = 'dashboard.staging.events.ringcentral.com', _d['hopin.com'] = 'dashboard.events.ringcentral.com', _d['staging.events.ringcentral.com'] = 'dashboard.staging.events.ringcentral.com', _d['events.ringcentral.com'] = 'dashboard.events.ringcentral.com', _d['stg.dashboard.hopin.com'] = 'dashboard.staging.events.ringcentral.com', _d['dashboard.hopin.com'] = 'dashboard.events.ringcentral.com', _d['dashboard.staging.events.ringcentral.com'] = 'dashboard.staging.events.ringcentral.com', _d['dashboard.events.ringcentral.com'] = 'dashboard.events.ringcentral.com', _d);
var ENV_OVERRIDE_KEY = 'environment';

var getEnvironment = function getEnvironment() {
  var override = (0, overrides_1.getLocalOverride)(ENV_OVERRIDE_KEY);
  var environment;

  if (window_1.polymorphicWindow) {
    environment = override !== null && override !== void 0 ? override : HOSTNAME_ENV_MAP[window.location.hostname.includes(REVIEW_APP_HOST) ? REVIEW_APP_HOST : window.location.hostname];
  }

  if (!environment) {
    throw new Error("Environment not found for hostname ".concat(window_1.polymorphicWindow === null || window_1.polymorphicWindow === void 0 ? void 0 : window_1.polymorphicWindow.location.hostname));
  }

  return environment;
};

exports.getEnvironment = getEnvironment;

var setEnvironment = function setEnvironment(env) {
  (0, overrides_1.setLocalOverride)(ENV_OVERRIDE_KEY, env);
};

exports.setEnvironment = setEnvironment;

var getInterpolations = function getInterpolations(hostname) {
  return {
    '{events}': EVENTS_HOST[hostname],
    '{apps}': APPS_STORE_HOST[hostname],
    '{dashboard}': DASHBOARD_HOST[hostname],
    '{host}': hostname,
    '{branch}': hostname.split('.')[0]
  };
};

var interpolateValues = function interpolateValues(value) {
  if (value === void 0) {
    value = '';
  }

  var interpolationMap = getInterpolations(window.location.hostname);
  return Object.entries(interpolationMap).reduce(function (prev, _a) {
    var key = _a[0],
        value = _a[1];
    return prev.replace(key, value);
  }, value);
}; // NOTE: When we need constants that aren't just strings, we should create a new
// function and typings to support that, in order to keep this functionality
// clean and simple.


var createGetEnvVar = function createGetEnvVar(values, overrideKey) {
  return function (forcedEnv) {
    var value = (0, overrides_1.getLocalOverride)(overrideKey);

    if (!value) {
      var environment = forcedEnv !== null && forcedEnv !== void 0 ? forcedEnv : (0, exports.getEnvironment)();
      var valueForEnv = interpolateValues(values[environment]);

      if (!valueForEnv) {
        throw new Error("No value found for key ".concat(overrideKey, " and environment ").concat(environment));
      }

      value = valueForEnv;
    }

    return value;
  };
};

exports.createGetEnvVar = createGetEnvVar;